module.exports = __webpack_public_path__ + "img/common-function.0f45023f.png";